import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '@/store'

const selectViewState = (state: RootState) => state.dashboardTasks

export const selectDashboardTasks = createSelector(selectViewState, (state) => state.tasks)
